import tmhRequest from "@/config/tmhRequest";

export default {
  searchServiceOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/searchserviceorder",
      method: "post",
      params: data
    });
  },

  searchServiceOrderCount: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/searchserviceordercount",
      method: "post",
      data: data
    });
  },

  searchServiceOrderByPage: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/searchserviceorderbypage",
      method: "post",
      data: data
    });
  },

  initTargetAdviser: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetadviser",
      method: "post",
      params: data
    });
  },

  initTargetBeautician: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetbeautician",
      method: "post",
      params: data
    });
  },

  initTargetRoom: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetroom",
      method: "post",
      params: data
    });
  },

  initTargetMarket: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetmarket",
      method: "post",
      params: data
    });
  },

  createServiceOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/createserviceorder",
      method: "post",
      data: data
    });
  },

  editServiceOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/editserviceorder",
      method: "post",
      data: data
    });
  },
  closeServiceOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/closeserviceorder",
      method: "post",
      params: data
    });
  },
  initTargetCooperateMyCoupon: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetcooperatemycoupon",
      method: "post",
      data: data
    });
  },
  initTargetNormalMyCoupon: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetnormalmycoupon",
      method: "post",
      data: data
    });
  },
  initTargetOffCard: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetoffcard",
      method: "post",
      params: data
    });
  },
  dealTargetDiscount: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/dealtargetdiscount",
      method: "post",
      data: data
    });
  },
  confirmServiceOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/confirmserviceorder",
      method: "post",
      data: data
    });
  },
  initTargetMyCard: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetmycard",
      method: "post",
      params: data
    });
  },
  initTargetBalance: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inittargetbalance",
      method: "post",
      params: data
    });
  },
  mixPayServiceOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/mixpayserviceorder",
      method: "post",
      data: data
    });
  },
  payServiceOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/payserviceorder",
      method: "post",
      data: data
    });
  },
  dealBeauticianDefaultWorkTime: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/dealbeauticiandefaultworktime",
      method: "post",
      data: data
    });
  },
  initHistoryPerformance: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/inithistoryperformance",
      method: "post",
      data: data
    });
  },
  initServiceOrderPerformance: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/initserviceorderperformance",
      method: "post",
      data: data
    });
  },

  dealServiceOrderPerformance: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/dealserviceorderperformance",
      method: "post",
      data: data
    });
  },

  auditServiceOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/auditserviceorder",
      method: "post",
      params: data
    });
  },

  searchListIspaServiceOrder: function(data) {
    return tmhRequest({
      url: "/ispa/order/ispaserviceorder/searchlistispaserviceorder",
      method: "post",
      params: data
    });
  },

  transferServiceOrder: function(data) {
    return tmhRequest({
      url: "/ispa/order/serviceorder/transferserviceorder",
      method: "post",
      params: data
    });
  },

  repairSettlementDetail: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/repairsettlementdetail",
      method: "post",
      params: data
    });
  },

  repairEmployeePerformance: function(data) {
    return tmhRequest({
      url: "/order/ispa/serviceorder/repairemployeeperformance",
      method: "post",
      params: data
    });
  },
  /* ------------------------------------------------------------- */

  repairServiceOrderInvoice: function(data) {
    return tmhRequest({
      url: "/order/serviceorder/repairserviceorderinvoice",
      method: "post",
      params: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/ispa/order/serviceorder.js